<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="template-list-container">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="m-0">Templates</h3>
    <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;" (click)="addTemplate()">
      New Template +
    </button>
  </div>

  @if (loading) {
    <div class="text-center p-4">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    </div>
  }

  @if (!loading) {
    <p-table [value]="templates" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]"
      styleClass="p-datatable-striped" [tableStyle]="{'min-width':'50rem'}" [resizableColumns]="true" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 10%">ID</th>
          <th style="width: 30%">Name</th>
          <th style="width: 30%">Description</th>
          <th style="width: 15%">Tasks</th>
          <th style="width: 10%">Status</th>
          <th style="width: 5%">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr>
          <td>{{template.templateId}}</td>
          <td>{{template.name}}</td>
          <td>{{template.description || '-'}}</td>
          <td>{{getTaskCount(template)}}</td>
          <td>
            <span [class]="template.isActive ? 'badge bg-success' : 'badge bg-secondary'">
              {{template.isActive ? 'Active' : 'Inactive'}}
            </span>
          </td>
          <td>
            <div class="d-flex gap-2">
              <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
              (click)="editTemplate(template)" pTooltip="Edit" tooltipPosition="top"></button>
              <button pButton pRipple type="button" [icon]="template.isActive ? 'pi pi-eye-slash' : 'pi pi-eye'"
                class="p-button-rounded p-button-text p-button-sm" (click)="toggleActive(template)"
              [pTooltip]="template.isActive ? 'Deactivate' : 'Activate'" tooltipPosition="top"></button>
              <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger"
              (click)="deleteTemplate(template)" pTooltip="Delete" tooltipPosition="top"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center p-4">
            <p>No templates found. Click "New Template +" to create one.</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

